// 2019-10-24 
// aleiku
// NotificationCenter v2.0

let subscriberUid = -1;

export const NotificationName = {
  'AuthDenied'                : 'NotificationNameAuthDenied',
  'PermissionsDidChanged'     : 'NotificationNamePermissionsDidChanged',
  'PageLayoutDidChanged'      : 'NotificationNamePageLayoutDidChanged',
  'PageNeedCheckDataItems'    : 'NotificationNamePageNeedCheckDataItems',
  'PageCleanCache'            : 'NotificationNamePageCleanCache',
  'PageOnSubmit'              : 'NotificationNamePageOnSubmit',
  'PageUseSampleImage'        : 'NotificationNamePageUseSampleImage',
  'PageRequestImageDidChange' : 'NotificationNamePageRequestImageDidChange',
}

// const default = new NotificationCenter()
let notificationCenterDefault = null

export default class NotificationCenter {
  // TODO: 這樣寫會報錯，應該是ES6的關係之後再修正
  // static default = NotificationCenter.default == null ? new NotificationCenter() : this.default;
  static get default () {
    if (notificationCenterDefault == null) {
      notificationCenterDefault = new NotificationCenter()
    }
    return notificationCenterDefault
  }

  constructor() {
    this.observers = [];
  }

  addObserver(observer, callback, eventName = null, object = null) {
    let token = (++subscriberUid).toString();
    this.observers.push({
      token     : token,
      observer  : observer,
      callback  : callback,
      eventName : eventName,
      object    : object,
    })
    return token
  }
  
  removeObserver(observer, eventName = undefined) {
    this.observers = this.observers.filter(observerInfo => {
      if (observerInfo.observer === observer) {
        // 不指定eventName remove all
        if (eventName === undefined) return false

        if (eventName === observerInfo.eventName) return false
      }
      return true
    })
  }

  post(eventName, object) {
    this.observers.filter(item => item.eventName === null || item.eventName === eventName)
    .forEach(item => {
      if (item.callback instanceof Function) {
          item.callback({
            eventName:eventName,
            object:object,
            observer:item.observer,
            observerObject:item.object,
          })
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/libs/NotificationCenter.js